<template>
    <div class="form-group">
        <label class="form-label" :for="id" :style="{ width: labelWidth }">
            <span v-if="required" style="color: #ff5a5a;">*</span>
            <span v-else style="visibility: hidden;">*</span>
            {{ label }}
        </label>
        <div class="input-container" :style="{ width: inputDivWidth }">
            <input
                :type="type"
                :id="id"
                v-model="localModelValue"
                class="form-input"
                :placeholder="placeholder"
                :required="required"
                :disabled="disabled"
                :style="{ width: inputWidth }"
                @blur="validate"
                autocomplete="off"
            />
            <div v-if="inputImg" class="input-img-container">
                <img src="@/assets/assets/location.png" class="location" @click="handleImgClick" />
            </div>
            <div v-if="error" class="error-message">{{ error }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
        },
        type: {
            type: String,
            default: "text",
        },
        id: {
            type: String,
            required: true,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        placeholder: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
        inputImg: {
            type: Boolean,
            default: false,
        },
        labelWidth: {
            type: String,
            default: "40%",
        },
        inputWidth: {
            type: String,
            default: "100%",
        },
        inputDivWidth: {
            type: String,
            default: "100%",
        },
        rules: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            error: "",
            localModelValue: this.modelValue,
        };
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                // console.log("modelValue updated:", newValue);
                this.localModelValue = newValue;
            },
        },
        localModelValue: {
            handler(newValue) {
                    this.$emit('update:modelValue', newValue);
            },
        },
    },
    methods: {
        handleImgClick() {
            this.$emit("img-click", this.id);
        },
        validate() {
            this.error = "";
            for (const rule of this.rules) {
                if (rule.required && !this.localModelValue) {
                    this.error = rule.message;
                    return;
                }
            }
        },
        reset() {
            this.localModelValue = '';
            this.$emit('update:modelValue', '');
        },
    },
};
</script>
<style scoped>
.form-group {
    display: flex;
    align-items: center;
    width: 100%;
}

.form-label {
    display: block;
    color: #94a3b8;
    font-size: 0.9rem;
    width: 40%;
    white-space: nowrap;
}

.input-container {
    display: flex;
    align-items: center;
    width: 100%;
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 5px;
    background: rgb(14, 27, 52);
    padding: 0rem 1rem;
    box-sizing: border-box;
    height: 45px;
}

.form-input {
    width: 100%;
    background: rgb(14, 27, 52);
    border: none;
    border-radius: 10px;
    color: #fff;
    font-size: 1rem;
    transition: all 0.3s ease;
    /*height: 43px;*/
    padding-left: 0.3rem;
}

.form-input:focus {
    outline: none;
    border-color: #00ff96;
    margin-left: 0.5rem;
}

.form-input::placeholder {
    color: #64748b;
}

.form-input:disabled {
    color: #888;
    cursor: not-allowed;
}

.input-img-container {
    cursor: pointer;
}

.location {
    width: 15px;
    height: 24px;
}

.error-message {
    color: red;
    font-size: 0.8rem;
}
</style>